<template>
    <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" :width="width" :height="height" version="1.1"
         style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
         viewBox="0 0 51 50"
         xmlns:xlink="http://www.w3.org/1999/xlink">
         <g id="Слой_x0020_1">
          <metadata id="CorelCorpID_0Corel-Layer"></metadata>
          <path class="frame-fill frame-stroke" :class="{'frame-active':selected}"
               d="M41 41c15,3 8,-36 6,-37 -6,-6 -14,-4 -21,2 -13,-6 -20,-7 -23,-1 -2,3 -3,9 -3,18 0,5 2,9 4,15 4,11 2,15 12,7 4,-3 10,-6 24,-3z"></path>
         </g>
    </svg>
</template>

<script>
    import {implantMixin} from '@/mixins/implant.js'

    export default {
        mixins: [implantMixin]

    }
</script>
